import styled, { css } from 'styled-components'

const designerCSS = css``
const summaryCSS = css`
  details summary,
  .static_summary summary {
    display: flex;
    z-index: 1;
    position: relative;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px;
    transition-property: color, background-color;
  }

  details summary.close {
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    background: var(--summary-bg-color-close);
    height: ${({ isPanelOpen }) => (isPanelOpen ? 'auto' : '60px')};
  }

  details summary.open {
    border-bottom: 0;
    background: var(--summary-bg-color-open);
    height: auto;
  }
`

const svgPlusCSS = css`
  details summary svg {
    width: 1em;
    height: 1em;
    fill: currentColor;
    transition: all 0.5s;
  }
  details summary svg.plus {
    visibility: visible;
    opacity: 1;
  }
  details summary svg.plus.panelClosed {
    opacity: 0;
  }
  details summary svg.plus.open {
    transform: rotate(45deg);
    transition-property: transform;
    filter: drop-shadow(0px 0px 3px #2a6dff);
  }
`
const developerCSS = css``

export const PanelSectionBaseCSS = styled.div`
  ${designerCSS}
  ${summaryCSS}
  ${svgPlusCSS}
  ${developerCSS}
`
